import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import LoginProvider from "../../onboarding/login/LoginProvider";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { SettingsPersonalInfoModel } from "../../../model/settings/SettingsPersonalInfoModel";
import { navigate } from "../../../service/navigation/Navigation";
import ShowToast from "../../../widget/common/ui/Toast";
import AppConfigService from "../../../service/app_config/AppConfigService";
import { SettingsCompanyCheckUpdatesModel } from "../../../model/settings/SettingsCompanyCheckUpdatesModel";

const SettingsProvider = new (class SettingsProvider {
  navigate = (url: string | number) => {
    //if (UtilityHelper.isNotEmpty(url)) {
    navigate(url);
    //}
  };

  logout = () => {
    LoginProvider.logout();
  };

  getProfileAPI = async (): Promise<SettingsPersonalInfoModel | null> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    const url: string = `${ApiUrls.baseUrl}profile/get_personal_details`;
    const body: any = {
      account_id: accountId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const settingsPersonalInfoModel: SettingsPersonalInfoModel = response;
        return settingsPersonalInfoModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };

  checkUpdatesAPI = async (): Promise<boolean> => {
    ApiUrls.init();

    const companyCode = AppConfigService.get("company_code") || "";
    //const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    //const branchId: string = CacheStorage.getValue(StorageKeys.branch_id);
    //String status =  await CachedStorage().getValue(key: "default_branch_config_status") ?? "0";

    const url: string = `${ApiUrls.baseUrl}device/check_company_updates`;
    const body: any = {
      company_code: companyCode,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const settingsCompanyCheckUpdatesModel: SettingsCompanyCheckUpdatesModel =
          response;

        AppConfigService.init(
          settingsCompanyCheckUpdatesModel.result?.company_update_details!
        );

        //this.navigate(0);
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }
    return false;
  };
})();

export default SettingsProvider;
